module.exports = __webpack_public_path__ + "static/media/mute.b2d29fbc.svg";